<template>
  <ul class="design">
    <li v-for="design in designs">
      <button class="button-product" @click="clickDesign(design)">
        <template v-if="design.image_front">
          <svg class="full-width" viewBox="0 0 580 460" v-html="design.image_front"></svg>
        </template>
        <template v-else-if="design.image_back">
          <svg class="full-width" viewBox="0 0 580 460" v-html="design.image_back"></svg>
        </template>
        <template v-else>
        <part v-for="part in design.parts" :key="'part-' + part.id" :part="part" :reverse="reverse"/>
        <letter v-for="letter in design.letters" :key="'letter-' + letter.id" :letter="letter" :reverse="reverse"/>
        </template>
      </button>
      <div class="price">{{ design._matchingData.Figures.price + design.add_price | currency }}~</div>

      <div :show.sync="modalShow" :class="{'uk-modal':true,'uk-open':modalShow}" v-if="selectedDesign === design" >
        <div class="uk-modal-dialog">
          <button class="uk-close uk-icon uk-modal-close-default" @click="modalShow = false">
            <svg width="14" height="14" viewBox="0 0 14 14"><path fill="none" stroke="#000" stroke-width="1.1" d="M1 1l12 12M13 1L1 13"></path></svg>
          </button>
          <div class="uk-modal-body">
            <div class="uk-modal-header">
              <h2 v-html="selectedDesign.name"></h2>
            </div>
            <div class="uk-modal-body">
              <carousel :perPage="1" :paginationPadding="0" :paginationSize="16">
                <slide>
                  <div class="image_wrapper">
                    <div class="image" v-if="design.image_front">
                      <svg viewBox="0 0 580 460" v-html="design.image_front"></svg>
                    </div>
                    <div class="image" v-if="!design.image_front">
                      <part v-for="part in selectedDesign.parts" :key="part.id" :part="part" :reverse="reverse"/>
                      <letter v-for="letter in selectedDesign.letters" :key="letter.id" :letter="letter"
                              :reverse="reverse"/>
                    </div>
                  </div>
                </slide>
                <slide>
                  <div class="image_wrapper">
                    <div class="image" v-if="design.image_back">
                      <svg viewBox="0 0 580 460" v-html="design.image_back"></svg>
                    </div>
                    <div class="image" v-if="!design.image_back">
                      <part v-for="part in selectedDesign.parts" :key="part.id" :part="part" :reverse="!reverse"/>
                      <letter v-for="letter in selectedDesign.letters" :key="letter.id" :letter="letter"
                              :reverse="!reverse"/>
                    </div>
                  </div>
                </slide>
              </carousel>
              <div class="center">{{ selectedDesign._matchingData.Figures.price + selectedDesign.add_price | currency }}〜</div>
              <div v-html="selectedDesign.comment"></div>
            </div>
            <div class="uk-modal-footer">
              <vk-button class="close" @click="modalShow = false">キャンセル</vk-button>
              <vk-button class="close" @click="save">決定</vk-button>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
  import Part from '../../preview/Part.vue'
  import Letter from '../../preview/Letter.vue'
  import {mapState, mapActions} from 'vuex'
  import axios from 'axios/dist/axios.min'
  import { Carousel, Slide } from 'vue-carousel';

  export default {
    name: 'design',
    components: {
      Part, Letter, Carousel, Slide
    },
    data(){
      return {
        category_id: null,
        figure_id: null,
        designs: [],
        reverse: 0,
        modalShow: false,
        selectedDesign: {
          name:'',
          comment:'',
          price:'',
          image_front:'',
          image_back:'',
          _matchingData:{
            Figures:{
              price: ''
            }
          }
        },
      }
    },
    computed: {
      ...mapState(['cart']),
      selectedFigure () {
        return this.$store.state.cart.figure;
      },
    },
    methods: {
      ...mapActions(['selected_design']),
      initialize: function () {
        this.category_id = (this.$route.params.category_id) ? this.$route.params.category_id : this.$store.state.cart.category.id;
        this.figure_id = (this.$route.params.figure_id) ? this.$route.params.figure_id : this.$store.state.cart.figure.id;

        if (!this.$store.state.cart.figure) {
          this.$router.push({name: 'category'});
        }
        this.designs = [];
        this.$store.commit('setLoading');
        axios.get(`/designs.json?figure_id=${this.figure_id}`).then(response => {
          for (let i = 0; i < response.data.designs.length; i++) {
            this.designs.push(response.data.designs[i]);
          }
          this.$store.commit('resetLoading');
        });
      },
      save: function() {
        this.modalShow = false;
        this.selected_design(this.selectedDesign);
        this.$router.push({name:'color', params: {
          category_id: this.category_id,
          figure_id: this.figure_id,
          design_id: this.selectedDesign.id,
          }
        });
      },
      clickDesign: function (design) {
        this.selectedDesign = design;
        this.modalShow = true;
      }
    },
    created (){
      this.initialize();
    },
    deactivated(){
      this.$store.commit('resetLoading');
    },
    watch: {
      selectedFigure: function() {
        if (this.$store.state.cart.figure){
          this.initialize();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  button{
    position: relative;
    height: 90px;
    padding:0 10px;
  }
  .price{
    position: absolute;
    bottom: -6px;
    background-color: rgb(235,52,35);
    color:white;
    /*display: inline-block;*/
    border-radius: 6px;
    padding: 2px 4px;
    margin-left: 30px;
  }

  #product-menu .product_list > ul > li button.close {
    background: #151d66;
    height: auto;
    color: white;
    margin-right: 2px;
  }
  .uk-modal-body{
    color:black;
  }
  .uk-modal-header{
    text-align: center;
    background: #151d66;
    color: white;
    padding: 1em;
    border-radius: 1em;
  }
  .uk-modal-header h2{
    color: white;
  }
  .uk-modal-footer{
    text-align: center;
  }
  /* アニメーション後に自動でuk-openがついてくれなくなったので仕方なくvk-modalを自分で実装 */
  .uk-modal.uk-open{
    display:block;
  }
  #product-menu .product_list > ul > li button.info {
    width: 20px;
    height: 20px;
    position: absolute;
    background: #151d66;
    color: white;
    top: -2px;
    right: -2px;
    border: 1px solid silver;
  }
  .center {
    text-align: center;
  }
  .image_wrapper{
    position:relative;
  }
  .image_wrapper:before{
    display: block;
    content: '';
    padding-top: 80%;
  }
  .image_wrapper .image{
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  .full-width {
    position: absolute;
    margin: 0;
    top: 0;
    left: 0;
    width: 100%;
  }
</style>
